import { collection, getDocs } from "firebase/firestore";
import { firestore, isFirebaseConfigured } from "@/lib/firebase";

const LOCAL_ORDERS_KEY = "weborder.localOrders";

function getLocalOrders() {
  try {
    return JSON.parse(localStorage.getItem(LOCAL_ORDERS_KEY) || "[]");
  } catch {
    return [];
  }
}

function normalizePlatform(value = "") {
  const text = String(value).toLowerCase();
  if (text.includes("ios")) return "ios";
  if (text.includes("desktop") || text.includes("windows") || text.includes("mac")) return "desktop";
  if (text.includes("android")) return "android";
  return null;
}

function platformFromOrder(order) {
  return normalizePlatform(order.platform || order.app_platform || order.app_title || order.app_id);
}

function addApprovedOrderCounts(stats, orders = []) {
  orders.forEach((order) => {
    if (order.status !== "approved") return;
    const platform = platformFromOrder(order);
    if (!platform) return;
    const current = stats[platform] || {};
    stats[platform] = {
      ...current,
      downloads: Math.max(Number(current.downloads || 0), Number(current.downloads || 0) + 1),
      source: current.source || "orders",
    };
  });
}

function readStatsDoc(snapshot) {
  const data = snapshot.data() || {};
  const platform = normalizePlatform(data.platform || snapshot.id);
  if (!platform) return null;
  return {
    platform,
    downloads: typeof data.downloads === "number" ? data.downloads : null,
    source: "firebase",
  };
}

export async function loadEditionStats() {
  const stats = {};

  addApprovedOrderCounts(stats, getLocalOrders());

  if (!isFirebaseConfigured || !firestore) return stats;

  try {
    const statSnapshots = await Promise.allSettled([
      getDocs(collection(firestore, "app_stats")),
      getDocs(collection(firestore, "appStats")),
    ]);

    statSnapshots.forEach((result) => {
      if (result.status !== "fulfilled") return;
      result.value.docs.forEach((snapshot) => {
        const docStats = readStatsDoc(snapshot);
        if (!docStats) return;
        stats[docStats.platform] = {
          ...(stats[docStats.platform] || {}),
          ...docStats,
        };
      });
    });
  } catch {
    // Stats collection is optional.
  }

  try {
    const ordersSnapshot = await getDocs(collection(firestore, "orders"));
    addApprovedOrderCounts(stats, ordersSnapshot.docs.map((snapshot) => ({
      order_id: snapshot.id,
      ...snapshot.data(),
    })));
  } catch {
    // Public order reads may be restricted; local/backend stats still work.
  }

  return stats;
}
